import React from 'react';
import Widget from 'components/Widget/Widget';
import ProductBundlesTable from './Tables/ProductBundlesTable';

const ProductBundles = ({
  height,
  index,
  data,
  configuration,
  disableFilter,
  cardFilterComponent,
}) => {
  return (
    <Widget
      icon={
        data?.defaultFilter?.integration_type ? (
          <img
            src={`/icons/integrations/${data?.defaultFilter?.integration_type}.svg`}
            className='w-5 h-5 '
          />
        ) : null
      }
      cardFilterComponent={cardFilterComponent}
      tableWidget
      widget_key={'product_bundles' + index}
      title={data.title}
      index={index}
      deleteWidget={true}
      data={data}
      default_filter={data.defaultFilter}
      configuration={configuration}
      disableDateFilter
      disableStatusFilter
      disableAccountsFilter
      showIntegrationFilters
      design={false}
      disableFilter={disableFilter}
      position={data?.position}
      dashboard_widget_key={data?.key}
    >
      <ProductBundlesTable height={height} index={index} />
    </Widget>
  );
};

export default ProductBundles;
